import React from "react";
import Tooltip from "react-native-walkthrough-tooltip";
import { AppColors } from "../../../utility/AppColors";
import {
  Image,
  ScrollView,
  Text,
  TouchableHighlight,
  TouchableOpacity,
  TouchableWithoutFeedback,
  View,
} from "react-native";
import ImageComponent from "../../ImageComponent";
import { AppImages } from "../../../utility/AppImages";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { useTooltips } from "../../../context/WalkthroughContext";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import { CropImage } from "../../choose-avatar-components/CropImage";
import UserCredits from "../../profile-common-components/UserCredits";
import Separator from "../../Separator";
import ProfileTooltip from "../../profile-common-components/ProfileTooltip";
import Avatar from "../../choose-avatar-components/Avatar";

const BalanceWalkthrough = ({ content, setActiveTab, scrollViewRef }) => {
  const {
    creditTooltipVisible,
    setCreditTooltipVisible,
    setRankingTooltipVisible,
    currentStep,
    totalSteps,
    handleNextStep,
  } = useTooltips();
  const deviceSize = useDeviceSize();

  const handleNextStepForRankTooltip = () => {
    if (
      deviceSize === DEVICE_SIZES.XS ||
      deviceSize === DEVICE_SIZES.SM ||
      deviceSize === DEVICE_SIZES.MD ||
      deviceSize === DEVICE_SIZES.LG
    ) {
      setActiveTab(4);
    }
    scrollViewRef.current?.scrollTo({
      y:
        deviceSize === DEVICE_SIZES.XS ||
        deviceSize === DEVICE_SIZES.SM ||
        deviceSize === DEVICE_SIZES.MD ||
        deviceSize === DEVICE_SIZES.LG
          ? 0
          : 800,
      animated: true,
    });

    setTimeout(() => {
      setRankingTooltipVisible(true);
    }, 500);
  };

  return (
    <Tooltip
      isVisible={creditTooltipVisible}
      contentStyle={{
        backgroundColor: AppColors.purple_453B50,
        width:
          deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
            ? 350
            : 736,
        borderColor: AppColors.white,
        shadowColor: "rgba(255, 255, 255, 0.65)",
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.65,
        shadowRadius: 10.1,
        elevation: 5,
        borderWidth: 1,
        height: "auto",
      }}
      displayInsets={{
        top:
          deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
            ? 30
            : deviceSize === DEVICE_SIZES.MD || deviceSize === DEVICE_SIZES.LG
            ? 100
            : 84,
        bottom: 0,
        left:
          deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
            ? 10
            : deviceSize === DEVICE_SIZES.MD || deviceSize === DEVICE_SIZES.LG
            ? 50
            : 200,
        right: 10,
      }}
      arrowStyle={{ display: "none" }}
      content={
        <ScrollView
          style={{
            ...(deviceSize === DEVICE_SIZES.XS ? { maxHeight: 400 } : {}),
          }}
          showsHorizontalScrollIndicator={false}
        >
          <View>
            <View
              style={{
                flexDirection:
                  deviceSize === DEVICE_SIZES.SM ||
                  deviceSize === DEVICE_SIZES.XS
                    ? "column"
                    : "row",
                gap: 10,
              }}
            >
              {" "}
              <TouchableOpacity
                onPress={() => {
                  setCreditTooltipVisible(false);
                }}
                style={{ position: "absolute", right: 0, top: 0, zIndex: 1 }}
              >
                <ImageComponent
                  url={AppImages.icCloseWhiteSvg}
                  style={{
                    height: 16,
                    width: 16,
                    resizeMode: "contain",
                  }}
                />
              </TouchableOpacity>
              <View
                style={{
                  gap: 10,
                  alignItems:
                    deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                      ? "center"
                      : "flex-start",
                  ...(deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? { flexDirection: "row" }
                    : { width: "25%" }),
                }}
              >
                <View style={{ gap: 8 }}>
                  <Avatar
                    src="https://squadify-avatar.s3.eu-west-2.amazonaws.com/tiger.svg"
                    variant="walkthroughPlayer"
                  />
                  {deviceSize === DEVICE_SIZES.XS ||
                    (deviceSize === DEVICE_SIZES.SM ? null : (
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_12,
                          { lineHeight: 21 },
                        ]}
                      >
                        <Text style={{ color: AppColors.green_00FFE8 }}>
                          Pro Tip :{" "}
                        </Text>
                        Upgrade to Pro for added benefits, better payouts, and
                        faster access to your rewards!
                      </Text>
                    ))}
                </View>
                {deviceSize === DEVICE_SIZES.XS ||
                deviceSize === DEVICE_SIZES.SM ? (
                  <Text
                    style={[
                      AppFontStyle.BOLD_ANYBODY_12,
                      { color: AppColors.white },
                    ]}
                  >
                    Available Credits & Redeem 💷
                  </Text>
                ) : null}
              </View>
              <View
                style={{
                  flex: 1,
                  marginTop:
                    deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                      ? 0
                      : 12,
                }}
              >
                <View>
                  {deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM ? null : (
                    <Text
                      style={[
                        AppFontStyle.BOLD_ANYBODY_16,
                        { color: AppColors.white, marginBottom: 10 },
                      ]}
                    >
                      Available Credits & Redeem 💷
                    </Text>
                  )}
                  <View>
                    <View>
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_12,
                          { lineHeight: 21 },
                        ]}
                      >
                        <Text style={{ color: AppColors.green_00FFE8 }}>
                          Your Credits:{" "}
                        </Text>
                        Credits are earned by redeeming belts and receiving
                        gifts from your audience during live streams.
                      </Text>
                    </View>
                    <View>
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_12,
                          { lineHeight: 21 },
                        ]}
                      >
                        <Text style={{ color: AppColors.green_00FFE8 }}>
                          • Redeem Credits:{" "}
                        </Text>
                        Convert your credits into cash. Credits represent real
                        value and can be cashed out for your achievements on KO.
                      </Text>
                    </View>
                    <View>
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_12,
                          { lineHeight: 21 },
                        ]}
                      >
                        <Text style={{ color: AppColors.green_00FFE8 }}>
                          Unlock Pro Member Benefits:{" "}
                        </Text>
                        Becoming a Pro Member offers exclusive advantages when
                        redeeming credits.
                      </Text>
                    </View>
                    <View>
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_12,
                          { lineHeight: 21 },
                        ]}
                      >
                        <Text style={{ color: AppColors.green_00FFE8 }}>
                          • Higher Cash-Out Limit:{" "}
                        </Text>
                        Redeem more credits daily with an increased limit
                        exclusive to Pro Members.
                      </Text>
                    </View>{" "}
                    <View>
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_12,
                          { lineHeight: 21 },
                        ]}
                      >
                        <Text style={{ color: AppColors.green_00FFE8 }}>
                          • Reduced Platform Fees:{" "}
                        </Text>
                        Keep a larger percentage of your earnings.
                      </Text>
                    </View>{" "}
                    <View>
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_12,
                          { lineHeight: 21 },
                        ]}
                      >
                        <Text style={{ color: AppColors.green_00FFE8 }}>
                          • Priority Pay-outs:{" "}
                        </Text>
                        Get your cash-out requests processed faster than
                        standard users.
                      </Text>
                    </View>
                    <View>
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_12,
                          { lineHeight: 21 },
                        ]}
                      >
                        <Text style={{ color: AppColors.green_00FFE8 }}>
                          • Enhanced Credibility:{" "}
                        </Text>
                        Show your Pro Member badge to build your reputation on
                        the platform.
                      </Text>
                    </View>
                  </View>
                </View>
              </View>
            </View>
            <View
              style={{
                gap: 10,
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <Text
                style={{
                  ...AppFontStyle.REGULAR_ANYBODY_12,
                  color: AppColors.green_00FFE8,
                }}
              >
                {currentStep + 1} / {totalSteps}
              </Text>

              <TouchableOpacity
                onPress={() => {
                  setCreditTooltipVisible(false);
                  handleNextStepForRankTooltip();
                  handleNextStep();
                }}
                style={{
                  backgroundColor: AppColors.appViolentColor_6D08C3,
                  width: 70,
                  height: 20,
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: 10,
                  cursor: "pointer",
                  shadowColor: "rgba(0, 0, 0, 0.25)",
                  shadowOffset: { width: 0, height: 4 },
                  shadowOpacity: 0.25,
                  shadowRadius: 4,
                  elevation: 4,
                }}
              >
                <Text style={AppFontStyle.BOLD_ANYBODY_12}>Next</Text>
              </TouchableOpacity>
            </View>
          </View>
        </ScrollView>
      }
      placement={"top"}
    >
      <TouchableHighlight style={{ width: "100%" }}>
        {content}
      </TouchableHighlight>
    </Tooltip>
  );
};

export default BalanceWalkthrough;
